/** Visual severity of a hub notification banner/alert. */
export const styleTypes = {
  WARNING: 'warning',
  ERROR: 'error',
  SUCCESS: 'success',
  INFO: 'info',
} as const;

/** Visual severity value — one of {@link styleTypes}. */
export type StyleType = (typeof styleTypes)[keyof typeof styleTypes];

// Bounded to notifications in de.json | en.json
export const messageTypes = {
  NEW_VERSION: 'newVersion',
  NEW_VERSION_PC: 'newVersionPc',
  NEW_VERSION_MAC: 'newVersionMac',
  PERFORMANCE_TRACKING: 'performanceTracking',
  PERFORMANCE_TRACKING_DRAFT: 'performanceTrackingDraft',
  NO_CONNECTION: 'noConnection',
  DEMO_ACCOUNT: 'demoAccount',
  REVIEW_INTENT: 'reviewIntent',
  REVIEW_INTENT_DEMO: 'reviewIntentDemo',
  DEPLOYMENT_READY: 'deploymentReady',
} as const;

/** Well-known notification message key (maps to an i18n entry under `notifications.*`) — one of {@link messageTypes}. */
export type MessageType = (typeof messageTypes)[keyof typeof messageTypes];
